const state = () => ({
  currentStep: 'step1',
  lastStep: 1,
  done: {
    step1: false,
    step2: false,
    step3: false,
    step4: false,
  },
  info: {
    legalDocuments: [],
    country: {},
  },
  data: {
    email: '',
    password: '',
    title: '',
    first_name: '',
    last_name: '',
    birthdate: null,
    address: '',
    address_details: '',
    phone: '',
    legal_document_uuids: '',
    allow_direct_marketing: false,
    language: 'en_GB',
    service: 'rh',
    promoCode: '',
  },
  b2b: {
    invitation: {
      valid_invite: false,
      company: {},
      invite: {},
    },
    isEmployee: false,
    email_from_company: true,
  },
  STATUS: {
    IDLE: true,
    LOADING: false,
    LOADED: false,
    ERROR: false,
    ERROR_EMAIL: false,
    ERROR_LEGAL_DOCUMENTS: false,
    ERROR_INVITATION: false,
  },
  error: undefined,
});

export default state;
